import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Team = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
    strokeAsPrimary: true,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <g
        stroke={primaryColorToUse}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        clipPath='url(#clip0_2677_16324)'
      >
        <path d='M19.868 12.96H4.827v2.617m7.58-2.616v2.616m7.485-2.616v2.616M12.377 12.622V7.823m0 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M14.877 20.561a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M22.37 20.561a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M7.327 20.561a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0' />
      </g>
      <defs>
        <clipPath id='clip0_2677_16324'>
          <path fill={primaryColorToUse} d='M.377.96h24v24h-24z' />
        </clipPath>
      </defs>
    </svg>
  );
};
